import { render, staticRenderFns } from "./editblock.vue?vue&type=template&id=47b87638&"
import script from "./editblock.vue?vue&type=script&lang=js&"
export * from "./editblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports